import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DropdownState {
    data: {
        [key: string]: any[];
    };
}

const initialState: DropdownState = {
    data: {},
};

const dropdownSlice = createSlice({
    name: "dropdown",
    initialState,
    reducers: {
        setDropdown: (
            state,
            action: PayloadAction<{ key: string; data: any[] }>
        ) => {
            const { key, data } = action.payload;
            state.data[key] = data;
        },

        clearDropdown: (state, action: PayloadAction<string>) => {
            delete state.data[action.payload];
        },

        resetDropdown: (state) => {
            state.data = {};
        },
    },
});

export const dropdownActions = dropdownSlice.actions;
export default dropdownSlice.reducer;